import LocalizedClientLink from "@modules/common/components/localized-client-link"

type BreadcrumbItem = {
  label: string
  href?: string
}

type BreadcrumbsProps = {
  items: BreadcrumbItem[]
}

export default function Breadcrumbs({ items }: BreadcrumbsProps) {
  return (
    <nav aria-label="Breadcrumb">
      <ol className="flex items-center gap-1.5 text-sm flex-nowrap overflow-x-auto whitespace-nowrap">
        {items.map((item, index) => {
          const isLast = index === items.length - 1
          return (
            <li key={`${item.label}-${index}`} className="flex items-center gap-1.5">
              {isLast || !item.href ? (
                <span className="text-grey-90 font-medium" aria-current="page">
                  {item.label}
                </span>
              ) : (
                <>
                  <LocalizedClientLink
                    href={item.href}
                    className="text-grey-40 hover:text-brand-primary transition-colors"
                  >
                    {item.label}
                  </LocalizedClientLink>
                  <span className="text-grey-30" aria-hidden="true">/</span>
                </>
              )}
            </li>
          )
        })}
      </ol>
    </nav>
  )
}
